'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Typography } from '@/components/ui/typography';
import { Users, TrendingUp, HandHeart } from 'lucide-react';

interface Plan {
  name: string;
}

interface CommissionsSectionProps {
  plan: Plan;
}

export function CommissionsSection({ plan }: CommissionsSectionProps) {
  const t = useTranslations('planDetails.helpPlan.commissions');

  return (
    <SectionWrapper variant="default" padding="md" className="relative bg-gray-50 dark:bg-gray-900/50">
      <div className="container">
        <div className="mb-12 text-center">
          <Typography variant="h2" className="mb-4">
            {t('title')}
          </Typography>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Referral Commission */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-primary-200 dark:border-primary-800 hover:border-primary-400 dark:hover:border-primary-600 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
                <Users className="w-8 h-8 text-primary-600 dark:text-primary-400" />
              </div>
              <Typography variant="h3" className="text-xl font-bold text-gray-900 dark:text-white">
                {t('referral.title')}
              </Typography>
            </div>
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('referral.description')}
            </Typography>
          </div>

          {/* Stage Advancement Commission */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-blue-200 dark:border-blue-800 hover:border-blue-400 dark:hover:border-blue-600 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                <TrendingUp className="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <Typography variant="h3" className="text-xl font-bold text-gray-900 dark:text-white">
                {t('stageAdvancement.title')}
              </Typography>
            </div>
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('stageAdvancement.description')}
            </Typography>
          </div>

          {/* Give and Get Help */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-green-200 dark:border-green-800 hover:border-green-400 dark:hover:border-green-600 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
                <HandHeart className="w-8 h-8 text-green-600 dark:text-green-400" />
              </div>
              <Typography variant="h3" className="text-xl font-bold text-gray-900 dark:text-white">
                {t('giveAndGet.title')}
              </Typography>
            </div>
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('giveAndGet.description')}
            </Typography>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}

